import React from "react";
import { useLocation } from "react-router";

// Posição de rolagem de cada lista, enquanto a aba estiver aberta. Não vai
// para o localStorage: lembrar o scroll de ontem não ajuda ninguém.
const positions = {};

// O goTo("/") gera "/loja/" e a entrada direta é "/loja": é a mesma página.
export const scrollKey = (pathname) => pathname.replace(/\/+$/, "") || "/";

/**
 * Mantém a posição de uma lista entre idas e vindas ao produto.
 *
 * Precisa existir porque o useGoTo navega com history.replace: voltar do
 * produto não é um "voltar" do navegador, é uma navegação nova para a lista,
 * que remonta do zero e abriria no topo.
 *
 * A posição é gravada a cada rolagem, e não no unmount: quando o unmount
 * roda, a página seguinte já está no DOM e o navegador pode ter cortado o
 * scroll.
 */
export default function useScrollMemory() {
  const { pathname } = useLocation();
  const key = scrollKey(pathname);

  React.useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const target = positions[key] || 0;
    window.scrollTo(0, target);
    // um quadro depois, com a barra de categorias e os destaques já medidos
    const frame = window.requestAnimationFrame(() =>
      window.scrollTo(0, target),
    );
    return () => window.cancelAnimationFrame(frame);
  }, [key]);

  React.useEffect(() => {
    let frame = null;
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        positions[key] = window.pageYOffset;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [key]);
}
